/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import * as actionTypes from './actionTypes';

const initilaState = {
  calculatedInterestDetails: [],
  selectedInterestDetails: {},
  calculatedInterestPayload: {},
  drugInterestResponse: [],
  calculateduserInputs: {},
  fetchSearchScreenObj: {},
  selManId: [],
};

const reducer = (state = initilaState, action) => {
  switch (action.type) {
    case actionTypes.SET_CALCULATED_INTEREST_DATA: {
      return { ...state, calculatedInterestDetails: action.payload };
    }
    case actionTypes.RESET_CALCULATED_INTEREST_DATA: {
      return initilaState;
    }
    case actionTypes.SELECTED_INTEREST_DETAILS: {
      return { ...state, selectedInterestDetails: action.payload };
    }

    case actionTypes.CALCUALTED_DETAILS_PAYLOAD:
      return { ...state, calculatedInterestPayload: action.payload };
    case actionTypes.RESPONSE_GET_DRUG_INTEREST:
      return { ...state, drugInterestResponse: action.payload };
    case actionTypes.CALULATED_USER_INPUTS:
      return { ...state, calculateduserInputs: action.payload };
    case actionTypes.GET_SEARCH_SCREEN_DATA:
      return { ...state, fetchSearchScreenObj: action.payload };
    case actionTypes.SELECTED_REBATE_PROGRAM:
      return {
        ...state,
        selectedRebateProgram: action.selectedRebateProgram,
      };
    case actionTypes.SELECTED_MFG:
      return {
        ...state,
        selectedGrid: action.selectedGrid,
      };
    default:
      return state;
  }
};

export default reducer;
